var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_68_462)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.4278 13.1042L18.852 23.078L27.9326 24.4887L28.6156 23.6447L26.4278 13.1042Z",
  fill: "#91C4D4"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3724 24.514C31.3398 24.3874 33.5812 20.436 33.3786 15.6882C33.1761 10.9404 30.6064 7.19412 27.6391 7.3207C25.9289 7.39364 20.0415 5.50571 19.1425 7.53983L16.1425 9.03983L5.28369 22.676L6.11854 26.6982C6.16491 26.9216 6.34721 27.0915 6.57333 27.1219L13.8465 28.1012C14.5906 28.2014 15.3332 27.9063 15.8056 27.3227L22.9405 18.5069C23.7368 22.0751 25.9187 24.6186 28.3724 24.514Z",
  fill: "#397D93"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_68_462)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.82052 24.3463L6.92851 25.5206C6.51081 26.0615 6.63862 26.2965 7.29393 26.38L12.9364 27.0437L12.5075 24.9773L7.82052 24.3463Z",
  fill: "#91C4D4"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.37739 22.1994C5.12569 22.5307 5.32954 23.0102 5.74281 23.0588L12.9929 23.9116C13.726 23.9979 14.452 23.7023 14.9163 23.1285L26.9351 8.27854C26.9351 8.27854 27.3581 7.83407 27.9459 7.69112C28.669 7.51531 29.0449 7.54884 29.0449 7.54884C29.0449 7.54884 28.5349 7.30466 27.8757 7.20796C27.2165 7.11126 26.5699 7.01556 26.5699 7.01556L21.3653 6.40331C19.0959 6.13635 16.8545 7.08941 15.4724 8.90905L5.37739 22.1994Z",
  fill: "#91C4D4"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i_68_462)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8109 12.5803L16.0692 9.60704L23.7709 10.513L21.4486 13.4337L13.8109 12.5803Z",
  fill: "#397D93"
}));
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_68_462",
  x: 18.8521,
  y: 13.1042,
  width: 9.76367,
  height: 12.3845,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_68_462"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_68_462",
  x: 6.6875,
  y: 24.3463,
  width: 6.24878,
  height: 3.69748,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_68_462"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i_68_462",
  x: 13.8108,
  y: 9.60704,
  width: 9.96021,
  height: 4.82663,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_68_462"
})));
function SvgWhistle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhistle);
export default __webpack_public_path__ + "static/media/whistle.a41443830f9e8c8c6039e4f988bfff74.svg";
export { ForwardRef as ReactComponent };